import { NavigateOptions } from "react-router-dom";

let globalNavigate: ((to: any, options?: NavigateOptions) => void) | null =
  null;

const NODE_ENV = process.env.NODE_ENV;

export const setGlobalNavigate = (
  navFn: (to: any, options?: NavigateOptions) => void
) => {
  globalNavigate = navFn;
};

export const navigate = (to: any, options?: NavigateOptions) => {
  if (NODE_ENV === "development") {
    console.log(`[NAVIGATE] ${to}`);
  }

  if (!globalNavigate) {
    console.warn("⚠️ navigate() called before initialization");
    return;
  }
  globalNavigate(to, options);
};

/* 
import { NavigateOptions, To } from "react-router-dom";

let globalNavigate: ((to: To, options?: NavigateOptions) => void) | null = null;

export const setGlobalNavigate = (
  navFn: (to: To, options?: NavigateOptions) => void
) => {
  globalNavigate = navFn;
};

export const navigate = (to: To, options?: NavigateOptions) => {
  console.log("[NAVIGATE]", to);
  if (!globalNavigate) {
    console.warn("⚠️ navigate() called before initialization");
    return;
  }
  globalNavigate(to, options);
};
 */
/* import { NavigateFunction } from 'react-router-dom';

let navigator: NavigateFunction;

export function setNavigator(navigate: NavigateFunction) {
    navigator = navigate;
}

export function navigate(path: any, options?: any) {
    if (!navigator) throw new Error('Navigator is not set');
    navigator(path, options);
} */
